import { Box, Page } from '@zillow/constellation-10';
import Layout from '../Layout';
import PageHeading from '../PageHeading';
import { PropertyDropdownSkeleton } from '../PropertyDropdown/Skeleton';
import { TimeFrameDropdownSkeleton } from '../TimeFrameDropdown/skeleton';
import { LeadSummaryCountsSkeleton } from '../LeadSummaryCounts/Skeleton';
import { LeadsTableSkeleton } from '../LeadsTable/Skeleton';
import { filterContainerStyles } from '../../styles/contactsPageStyles';

export default function LeadsPageSkeleton() {
  return (
    <Layout>
      <Page.Content>
        <Box css={{ marginBottom: 'loose' }}>
          <PageHeading heading="Leads" />
        </Box>
        <Box css={filterContainerStyles}>
          <PropertyDropdownSkeleton />
          <TimeFrameDropdownSkeleton />
        </Box>
        <LeadSummaryCountsSkeleton />
        <LeadsTableSkeleton />
      </Page.Content>
    </Layout>
  );
}
